import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';

import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';

type Row = {
  id: string;
  no_action: string;
  responsable: string;
  actions: {
    type: 'preventiva' | 'correctiva' | '';
    criterio: string;
    done: 'si' | 'no' | '';
    observations: string;
  }[]
}

const mock = [
  'La acción cumplió su objetivo.',
  'La acción se cumplió en el tiempo establecido.',
  'Se asigaron los recursos necesarios para el cumplimiento de la acción.',
  'Para el caso de acciones correctivas para quejas o apelaciones, se determinó la causa raíz mediante la metodología de los 5 ¿Por qué?',
  'Los responsables de la acción contaron con el tiempo necesario para llevar a cabo el cumplimiento.'
]

const emptyForm: Row = {
  id: '',
  no_action: '',
  responsable: '',
  actions: mock.map(criterio => ({
    type: '',
    criterio,
    done: '',
    observations: '',
  }))
}

@Component({
  selector: 'ngx-sgm-formato-diezynueve',
  templateUrl: './formato-diezynueve.component.html',
})
export class FormatoDiezynueveComponent implements OnInit {
  @Input() stationId: string;
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      no_action: {
        title: 'No. de acción',
        filter: true,
      },
      responsable: {
        title: 'Responsable',
        filter: true,
      }
    },
    noDataMessage: 'Sin registros',
  };

  constructor(private sgmService: SgmService) {}

  ngOnInit() {
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');
    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
  }

  addActions () {
    this.row.actions.push({ type: '', criterio: '', done: '', observations: '' })
  }

  removeToArray (index: number, rows: Array<any>) {
    rows.splice(index, 1)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
